import { type ActivityContentObjectDetail, createActivityContentObjectDetail } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
import type { Activity } from 'models/activity';
import { createActivity } from '../../services';

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useCreateActivityMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<ActivityContentObjectDetail, Activity>({
    async mutationFn(activity) {
      const response = await createActivity({
        body: {
          /* eslint-disable @typescript-eslint/naming-convention -- Defined by BE API */
          description: activity.description,
          end_time: activity.endTime.toISOString(),
          html_description: activity.htmlDescription,
          is_dexcom: activity.isDexcom,
          is_withings: activity.isWithings,
          multiple_submissions: activity.multipleSubmissions,
          name: activity.name,
          periodicity_type: activity.periodicityType,
          programs_topic: { id: activity.programsTopicId },
          programs_topic_id: activity.programsTopicId,
          reminders: activity.reminders,
          start_time: activity.startTime.toISOString(),
          tasks: activity.tasks,
          times: activity.times,
          /* eslint-enable @typescript-eslint/naming-convention -- Defined by BE API */
        },
      });

      return createActivityContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
